/**
 * NationalId component used to get the user's national ID type and value
 * - used with account creation and can be a hidden input
 */

import PropTypes from 'prop-types';

import React from 'react';
import classNames from 'classnames';
import { TextInput } from '@paypalcorp/pp-react';
import { StyleSheet, css } from 'aphrodite';
import { getCountryInfo } from './util/localizer';
import _isEmpty from 'lodash/isEmpty';
import { Dropdown } from '@paypalcorp/pp-react';

const STYLES = StyleSheet.create({
	typeWrapper: {
		margin: '10px 0 0',
		position: 'relative',
	},
	errorMessage: {
		transition: 'all 0.25s ease-in-out'
	},
	dropdown: {
		padding: 0,
		textIndent: 12,
		boxSizing: 'content-box',
		appearance: 'none'
	},
	arrow: {
		position: 'absolute',
		right: 10,
		top: '50%',
		cursor: 'default',
		pointerEvents: 'none'
	},
	arrowError: {
		marginTop: -17
	},
	errorStyles: {
		height: '100%'
	}
});

class NationalId extends React.Component {
    static propTypes = {
		country: PropTypes.string,
		labelNationalIdType: PropTypes.string,
		labelNationalIdNumber: PropTypes.string,
		helpText: PropTypes.string,
		showErrorMessages: PropTypes.bool,
		value: PropTypes.string,
		errorMessageType: PropTypes.string,
		errorMessageNumber: PropTypes.string,
		defaultIdType: PropTypes.string,
		nationalIds: PropTypes.array,
		changeEmail: PropTypes.func,
		handleFocus: PropTypes.func,
		handleBlur: PropTypes.func,
		resetNationalId: PropTypes.func,
		validNationalIdType: PropTypes.func,
		validNationalIdNumber: PropTypes.func,
	};

    static defaultProps = {
        showErrorMessages: true,
        handleFocus: () => {},
        handleBlur: () => {},
        resetNationalId: () => {},
        validNationalIdType: () => {},
        validNationalIdNumber: () => {},
    };

    state = {
        idType: this.props.defaultIdType,
    };

    /**
	 * Call parent's handleFocus
	 * @param {String} nationalIdNumber - national ID number
	 */
    handleFocus = (nationalIdNumber) => {
		this.props.handleFocus(nationalIdNumber);
	};

    /**
	 * Call parent's handleBlur
	 * @param {String} nationalIdNumber - national ID number
	 */
    handleBlur = (nationalIdNumber) => {
		this.props.handleBlur(nationalIdNumber);
	};

    /**
	 * handleChangeNationalIdType
	 * @param {String} nationalIdType - national ID type
	 */
    handleChangeNationalIdType = (event) => {
		let nationalIdType = event.target.value;
		this.setState({ nationalIdType });
		if (nationalIdType) {
			this.props.validNationalIdType(nationalIdType);
		} else {
			this.props.resetNationalId();
		}
		return nationalIdType;
	};

    /**
	 * Call parent's handleFocus
	 * @param {String} nationalIdNumber - national ID number
	 */
    handleChangeNationalNumber = (nationalIdNumber) => {
		this.setState({ nationalIdNumber });
		if (nationalIdNumber) {
			this.props.validNationalIdNumber(nationalIdNumber);
		} else {
			this.props.resetNationalId();
		}
		return nationalIdNumber;
	};

    render() {
		const countryInfo = getCountryInfo(this.props.country);
		const { value: initialValue, errorMessageType, errorMessageNumber, showErrorMessages } = this.props;

		let typeWrapperClassNames = classNames(css(STYLES.typeWrapper), {
            'vx_has-error-with-message ppvx_field--error': errorMessageType,
            'ppvx_dropdown': true
        });

		// define the wrapper classNames, which handle showing error messages
		let numberWrapperClassNames = classNames(css(STYLES.typeWrapper), {
            'vx_has-error-with-message ppvx_field--error': errorMessageNumber
        });

		// Getting natiponal id's from props or from localizer
		const nationalIds = !_isEmpty(this.props.nationalIds) ? this.props.nationalIds : countryInfo.nationalIds;

		return (
			<div>
				{countryInfo.showNationalId && <div>
					<div className={typeWrapperClassNames}>
						<Dropdown
							label={this.props.labelNationalIdType || 'ID Type'}
							aria-label={this.props.labelNationalIdType || 'ID Type'}
							errorText={errorMessageType}
							placeholder=""
							id="nationalIdType"
							name="nationalIdType"
							onChange={(value) => this.handleChangeNationalIdType(value)}
							options={nationalIds.map((item) => {
								return {
									label: item.label,
									value: item.value
								}
							})}
						/>
					</div>

					<div className={numberWrapperClassNames} style={{ margin: '10px 0 0', position: 'relative' }}>
						<TextInput
							type="text"
							name="nationalIdNumber"
							id="nationalIdNumber"
							className="vx_form-control vx_form-control_complex"
							label={this.props.labelNationalIdNumber}
							placeholder=""
							required={true}
							value={initialValue}
							errorText={showErrorMessages && errorMessageNumber}
							onChange={(event) => this.handleChangeNationalNumber(event.target.value)}
							onFocus={(event) => this.handleFocus(event.target.value)}
							onBlur={(event) => this.handleBlur(event.target.value)}
						/>
					</div>
				</div>
				}
			</div>
		);
	}
}

export default NationalId;
